import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { useMe } from '../api/client';

/**
 * Wraps a write control. Anonymous viewers see a "Log in to <action>" link that returns
 * them here after login; banned accounts see a notice; everyone else sees the children.
 */
export function LoginGate({ action, children }: { action: string; children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return null;
  const user = me.data?.user ?? null;
  const next = encodeURIComponent(location.pathname + location.search);
  if (!user) {
    return (
      <p>
        <Link to={`/login?next=${next}`}>Log in to {action}</Link>
      </p>
    );
  }
  if (user.banned) {
    return <p className="notice error">Your account is banned. You can read but not contribute.</p>;
  }
  return <>{children}</>;
}

/** Route to /login?next=... for the current page (used by controls that are visible while anonymous). */
export function useLoginRedirect(): string {
  const location = useLocation();
  return `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
}
